import React, { useState } from 'react';
import { Check, FileText } from 'lucide-react';
import { copyCaption } from '@/lib/share';

export const CopyCaptionButton = ({ order }) => {
  const [done, setDone] = useState(false);
  const onClick = async () => {
    const ok = await copyCaption({
      address: order.property_address, city: order.city, state: order.state,
      photoCount: order.photo_count, slug: order.gallery_slug,
    });
    if (ok) { setDone(true); setTimeout(() => setDone(false), 2000); }
  };
  const Icon = done ? Check : FileText;
  return (
    <button type="button" onClick={onClick} data-testid={`portfolio-copy-caption-${order.id}`}
      className="flex-1 h-9 px-2 inline-flex items-center justify-center gap-1.5 text-sm whitespace-nowrap rounded-lg border border-white/15 text-[#E8E4DE] hover:border-[#C6A14A]/40 hover:text-[#C6A14A] transition-colors active:scale-95">
      <Icon className="h-4 w-4" />
      Copy Caption
    </button>
  );
};
